import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../user/user.service';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private timeoutDuration = 60 * 60 * 1000; // 60 minuti in millisecondi (3600000 ms)
  private timeoutId: any;

  constructor(
    private router: Router,
    private userService: UserService,
    private ngZone: NgZone,
    private authService: AuthService
  ) {

  }

  /**
   * Avvia il monitoraggio dell'inattività dell'utente.
   */
  startWatching() {
    this.resetTimeout(); // Avvia il timeout

    // Ascolta eventi dell'utente
    window.addEventListener('mousemove', () => this.resetTimeout());
    window.addEventListener('keydown', () => this.resetTimeout());
    window.addEventListener('click', () => this.resetTimeout());
    window.addEventListener('touchstart', () => this.resetTimeout());
  }

  /**
   * Reset del timeout ogni volta che l'utente interagisce
   */
  private resetTimeout() {
    clearTimeout(this.timeoutId);

    // Usa NgZone per evitare problemi con il Change Detection di Angular
    this.ngZone.runOutsideAngular(() => {
      this.timeoutId = setTimeout(() => this.logout(), this.timeoutDuration);
    });
  }

  /**
   * Logout automatico dell'utente dopo inattività
   */
  private logout() {
    const userData = this.userService.userData;

    const queryParams = userData.tokenUrl ? { token: userData.tokenUrl } : {};

    this.authService.logout().subscribe({
      next: () => {
        this.router.navigate(['/sign-in'], { queryParams: { ...queryParams, sessionExpired: true } });
      },
      error: (err) => {
        console.log('errorLogout', err);
        this.userService.clearUserData();
        localStorage.removeItem('isSupplier');
        this.router.navigate(['/sign-in'], { queryParams: { ...queryParams, errorLogout: true } });
      }
    });
  }

}
